<template>
    <div>
        <br>
        <button class="button download right" v-on:click="onDownloadLogClick($event)">Download event log</button>
    </div>
</template>

<script>
    export default {
        methods: {
            onDownloadLogClick (e) {
                e.preventDefault();
                window.open("/api/download/log?id=" + this.$store.state.dataView.currentId)
            }
        }
    }
</script>
